import React from 'react';

const Loader = ({ message = "Loading...", size = "h-10 w-10" }) => (
  <div className="flex flex-col items-center gap-2">
    <div className={`animate-spin border-4 border-gray-300 border-t-gray-900 rounded-full ${size}`} />
    <span className="text-sm text-gray-700">{message}</span>
  </div>
);

export default Loader;

